import { ConsultaVisitaModalComponent } from './consulta-visita-modal.component';
import { ConsultaVisitaRoutingModule } from './consulta-visita-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../../shared/shared.module';
import { ConsultaVisitaComponent } from './consulta-visita.component';

@NgModule({
    declarations: [ConsultaVisitaComponent, ConsultaVisitaModalComponent],
    imports: [
        ConsultaVisitaRoutingModule,

        SharedModule,
        CommonModule,

    ],
    entryComponents: [ConsultaVisitaModalComponent]
})
export class ConsultaVisitaModule { }
